export default [
  {
    path: 'preview',
    name: 'admin:pos:preview',
    component: () => import(/* webpackChunkName: "pos" */ '@/views/admin/pos/PosPreview.vue'),
  },
  {
    path: 'terminals',
    name: 'admin:pos:terminals',
    component: () => import(/* webpackChunkName: "pos" */ '@/views/admin/pos/RegisterTerminals.vue'),
  },
  {
    path: 'sessions',
    name: 'admin:pos:sessions',
    component: () => import(/* webpackChunkName: "pos" */ '@/views/admin/pos/CashierSessions.vue'),
  },
  {
    path: 'settings',
    name: 'admin:pos:settings',
    component: () => import(/* webpackChunkName: "pos" */ '@/views/admin/pos/Settings.vue'),
  },
]
